import { SegmentBUMapModel } from "../models/SegmentBUMapModel";
import { client } from "./API";

const SegmentBUMapService = {
  async getSegmentBUMaps() {
    const response = await client({
      url: "SegmentLOB/GetSegmentBUMapping",
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async createSegmentBUMap(
    data: SegmentBUMapModel
  ) {
    try {
      const response = await client({
        method: "post",
        url: "SegmentLOB/PostSegmentBUMapping",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteSegmentBUMap(
    data: SegmentBUMapModel
  ) {
    try {
      const response = await client({
        method: "delete",
        url: "SegmentLOB/DeleteSegmentBUMapping",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};
export default SegmentBUMapService;
